import React from "react"
import { Navbar, Nav, Image, Row } from 'react-bootstrap'
import '../Assets/Navbar.css'
import Auth from '../Utilities/Auth'
import { GiHamburgerMenu } from "react-icons/gi"
import { AiOutlineClose } from 'react-icons/ai'
import { BsNewspaper } from 'react-icons/bs'
import { MdOndemandVideo, MdKeyboardArrowRight, MdKeyboardArrowDown } from "react-icons/md"
import { useHistory, useLocation } from 'react-router-dom'
import { Box, Button, Grid } from "@material-ui/core"
import Menu from '../VideoPlayer/Menu'
import { FaUserCircle } from "react-icons/fa"

const canViewReport = JSON.parse(sessionStorage.getItem('canViewReport'))
const canViewVideo = JSON.parse(sessionStorage.getItem('canViewVideo'))
const canViewMacroEco = JSON.parse(sessionStorage.getItem('canViewMacroEco'))

const NavBar = ({ setSection, sections, isAdmin: _isAdmin }) => {
  const location = useLocation();

  let history = useHistory()

  const [menu, openMenu] = React.useState(false)
  const [menuItem, setMenu] = React.useState(true)

  const handleLogout = async () => {
    history.push("logout")
  }

  const handleOpen = async () => {
    openMenu(!menu)
    setMenu(true)
  }

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleUnClick = (event: React.MouseEvent<HTMLElement>) => {
    setTimeout(() => {
      setAnchorEl(null)
    }, 500);
  }

  const handlePush = async ({ page, params }: {
    page: "macroeco" | "publication" | "video",
    params: any,
  }) => {
    history.push(page)
    openMenu(false)
    setSection(params)
  }

  if (["/", "/dashboard"].includes(location.pathname)) {
    return (
      <div className="container-nav">
        <Navbar expand="lg">
          <Navbar.Brand href="/" style={{ fontFamily: "Arial Narrow, Arial, sans-serif", fontSize: 12, fontWeight: "bolder" }}>
            <Image src="/logo3.png" className="logo-navbar" />
          </Navbar.Brand>

          {Auth.isUserAuthenticated() &&
            <div className="ml-auto email-bar">
              <button className="btn-profile">
                <FaUserCircle style={{ fontSize: 26 }} />
                <div className="text-email"><p>{Auth.getEmail().length >= 10 ? Auth.getEmail().slice(0, 10) + "..." : Auth.getEmail()}</p></div>
              </button>
              <Nav.Link href="/logout">
                <div className="img-logout">
                  <p>LOG OUT</p>
                </div>
              </Nav.Link>
            </div>
          }

          <div className="logo-navbar-xs">
            <Image onClick={() => history.push("/")} src="/logo3.png" className="logo-xs" />
          </div>

          {Auth.isUserAuthenticated() &&
            <Nav className="burger">
              <GiHamburgerMenu onClick={handleOpen} className={menu ? "burger-icon active" : "burger-icon"} />
              <div className={menu ? (!_isAdmin ? "menu-auto active" : "menu-auto2 active") : "menu-auto"} >
                <div className={menu ? "header-bar active" : "header-bar"} >
                  <div className="user-img-xs" >
                    <Image src="/user.png" className="only-xs" />
                    <AiOutlineClose onClick={() => openMenu(false)} className="icons-close" />
                  </div>
                  <p>{"Email: " + Auth.getEmail()}</p>
                </div>
                <div className={menu ? "menu-bar active" : "menu-bar"}>
                  <h5 style={{ marginBottom: 0 }} >MENU</h5>
                </div>
                {menu && <div className={menu ? "menu-items active" : "menu-items"}>
                  {!_isAdmin ? (
                    <>
                      {/* Report */}
                      {canViewReport && (
                        <>
                          <div className="lists" onClick={() => handlePush({ page: "publication", params: null })}>
                            <BsNewspaper style={{ fontSize: 20, color: "rgb(0, 37, 97)" }} />
                            <p style={{ marginLeft: "15px", marginBottom: 0, fontSize: 20.8, color: "rgb(0, 37, 97)" }} >EQUITY RESEARCH</p>
                          </div>
                          <hr style={{ marginTop: 5, marginBottom: 5 }} />
                        </>
                      )}

                      {/* Macroeconomics */}
                      {canViewMacroEco && (
                        <>
                          <div className="lists" onClick={() => handlePush({ page: "macroeco", params: null })}>
                            <BsNewspaper style={{ fontSize: 20, color: "rgb(0, 37, 97)" }} />
                            <p style={{ marginLeft: "15px", marginBottom: 0, fontSize: 20.8, color: "rgb(0, 37, 97)" }} >MACROECONOMICS</p>
                          </div>
                          <hr style={{ marginTop: 5, marginBottom: 5 }} />
                        </>
                      )}

                      {/* Video */}
                      {canViewVideo && (
                        <>
                          <div style={{ marginBottom: "15px", display: "flex" }} className="lists" onClick={() => setMenu(menuItem ? false : true)} >
                            <MdOndemandVideo style={{ fontSize: 20, color: "rgb(0, 37, 97)" }} />
                            <h4 style={{ marginLeft: "15px", marginBottom: 0, fontSize: 20.8, color: "rgb(0, 37, 97)" }} >RECORDED LIVE SESSION</h4>
                          </div>

                          {menuItem && (
                            <>
                              <MdKeyboardArrowDown className="icons-arrow" />
                              <div>
                                {(sections || []).map((s, i, ss) => (
                                  <div key={i} onClick={() => handlePush({ page: "video", params: s.sectionName })} className={menuItem ? "list-item" : "hind"}>
                                    <p style={{ margin: 5 }} >{s.sectionName || ""}</p>
                                    {i !== ss.length - 1 && <hr style={{ margin: 0 }} />}
                                  </div>
                                ))}
                              </div>
                            </>
                          )}
                          {!menuItem && (
                            <MdKeyboardArrowRight className="icons-arrow" />
                          )}
                          <hr style={{ marginTop: 0 }} />
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {/* Report */}
                      <>
                        <div className="lists" onClick={() => handlePush({ page: "publication", params: null })}>
                          <BsNewspaper style={{ fontSize: 20, color: "rgb(0, 37, 97)" }} />
                          <p style={{ marginLeft: "15px", marginBottom: 0, fontSize: 20.8, color: "rgb(0, 37, 97)" }} >EQUITY RESEARCH</p>
                        </div>
                        <hr style={{ marginTop: 5, marginBottom: 5 }} />
                      </>

                      {/* Macroeconomics */}
                      <>
                        <div className="lists" onClick={() => handlePush({ page: "macroeco", params: null })}>
                          <BsNewspaper style={{ fontSize: 20, color: "rgb(0, 37, 97)" }} />
                          <p style={{ marginLeft: "15px", marginBottom: 0, fontSize: 20.8, color: "rgb(0, 37, 97)" }} >MACROECONOMICS</p>
                        </div>
                        <hr style={{ marginTop: 5, marginBottom: 5 }} />
                      </>

                      {/* Video */}
                      <>
                        <div style={{ display: "flex", alignItems: "center" }} className="lists" onClick={() => setMenu(menuItem ? false : true)} >
                          <MdOndemandVideo style={{ fontSize: 20, color: "rgb(0, 37, 97)" }} />
                          <h4 style={{ marginLeft: "15px", marginBottom: 5, fontSize: 20.8, color: "rgb(0, 37, 97)" }} >RECORDED LIVE SESSION</h4>
                          {menuItem ? <MdKeyboardArrowDown className="icons-arrow" /> : <MdKeyboardArrowRight className="icons-arrow" />}
                        </div>

                        {menuItem && (
                          <>
                            <div>
                              {(sections || []).map((s, i, ss) => (
                                <div key={i} onClick={() => handlePush({ page: "video", params: s.sectionName })} className={menuItem ? "list-item" : "hind"}>
                                  <p style={{ margin: 5 }} >{s.sectionName || ""}</p>
                                  {i !== ss.length - 1 && <hr style={{ margin: 0 }} />}
                                </div>
                              ))}
                            </div>
                          </>
                        )}

                        <hr style={{ marginTop: 0 }} />
                      </>
                    </>
                  )}
                  <div className="main-btn-logout">
                    <button className="button-logout-mobile" style={{ backgroundColor: "#ee3824", fontSize: 24, marginBottom: 20 }} onClick={() => handleLogout()}>
                      LOG OUT
                    </button>
                  </div>
                </div>}
              </div>
            </Nav>
          }
          {!Auth.isUserAuthenticated() &&
            <p></p>
          }

        </Navbar>
        {(location.pathname !== "/admin" && Auth.isUserAuthenticated() && window.innerWidth >= 500) && <Row>
          <Grid id="menu-mdUp" container alignItems="center" direction="row" justify="center" style={{ padding: 16 }}>
            <Grid item xs={12} lg={10}>
              <Grid id="menu-mdUp" container alignItems="center" direction="row" justify="center">
                <Box component={Grid} onMouseOver={handleUnClick} display={{ xs: "none", lg: "block" }} style={{ zIndex: 1050 }}>
                  <Button onClick={() => history.push("/dashboard")} >HOME</Button>
                </Box>

                {/* Report */}
                {_isAdmin
                  ? (
                    <Grid onMouseOver={handleUnClick} item xs={4} sm={4} lg={3} container justify="center" style={{ zIndex: 1050 }} >
                      <Button onClick={() => history.push("/publication")} >EQUITY RESEARCH</Button>
                    </Grid>
                  ) : (
                    canViewReport && (
                      <Grid onMouseOver={handleUnClick} item xs={4} sm={4} lg={3} container justify="center" style={{ zIndex: 1050 }} >
                        <Button onClick={() => history.push("/publication")} >EQUITY RESEARCH</Button>
                      </Grid>
                    )
                  )
                }

                {/* Macroeconomics */}
                {_isAdmin
                  ? (
                    <Grid onMouseOver={handleUnClick} item xs={4} lg={3} container justify="center" style={{ zIndex: 1050 }} >
                      <Button onClick={() => history.push("/macroeco")}>MACROECONOMICS</Button>
                    </Grid>
                  ) : (
                    canViewMacroEco && (
                      <Grid onMouseOver={handleUnClick} item xs={4} lg={3} container justify="center" style={{ zIndex: 1050 }} >
                        <Button onClick={() => history.push("/macroeco")}>MACROECONOMICS</Button>
                      </Grid>
                    )
                  )
                }

                {/* Video */}
                {_isAdmin
                  ? (
                    <Grid item sm={4} lg={3} container justify="center">
                      <Menu anchorEl={anchorEl} sections={sections} setAnchorEl={setAnchorEl} setSection={setSection} />
                    </Grid>
                  ) : (
                    canViewVideo && (
                      <Grid item sm={4} lg={3} container justify="center">
                        <Menu anchorEl={anchorEl} sections={sections} setAnchorEl={setAnchorEl} setSection={setSection} />
                      </Grid>
                    )
                  )
                }
              </Grid>
            </Grid>
          </Grid>
          <hr id="hr" style={{ width: "90%", margin: "auto", marginTop: "-15px", border: '1px solid #F5F5F5' }} />
        </Row>}
      </div>
    )
  }
  else {
    return (
      <div className="container-nav">
        <Navbar expand="lg">
          <Navbar.Brand href="/" style={{ fontFamily: "Arial Narrow, Arial, sans-serif", fontSize: 12, fontWeight: "bolder" }}>
            <Image src="/logo2.png" className="logo-navbar" />
          </Navbar.Brand>

          {Auth.isUserAuthenticated() &&
            <div className="ml-auto email-bar">
              <button className="btn-profile-theme2">
                <FaUserCircle style={{ fontSize: 26 }} />
                <div className="text-email-theme2"><p>{Auth.getEmail().length >= 10 ? Auth.getEmail().slice(0, 10) + "..." : Auth.getEmail()}</p></div>
              </button>
              <Nav.Link href="/logout">
                <div className="img-logout">
                  <p>LOG OUT</p>
                </div>
              </Nav.Link>
            </div>
          }

          <div className="logo-navbar-xs">
            <Image onClick={() => history.push("/")} src="/logo2.png" className="logo-xs" />
          </div>

          {Auth.isUserAuthenticated() &&
            <Nav className="burger">
              <GiHamburgerMenu onClick={handleOpen} className={menu ? "burger-icon-theme2 active" : "burger-icon-theme2"} />
              <div className={menu ? (!_isAdmin ? "menu-auto active" : "menu-auto2 active") : "menu-auto"} >
                <div className={menu ? "header-bar active" : "header-bar"} >
                  <div className="user-img-xs" >
                    <Image src="/user.png" className="only-xs" />
                    <AiOutlineClose onClick={() => openMenu(false)} className="icons-close" />
                  </div>
                  <p>{"Email: " + Auth.getEmail()}</p>
                </div>
                <div className={menu ? "menu-bar active" : "menu-bar"}>
                  <h5 style={{ marginBottom: 0 }} >MENU</h5>
                </div>
                {menu && <div className={menu ? "menu-items active" : "menu-items"}>
                  {!_isAdmin ? (
                    <>
                      {/* Report */}
                      {canViewReport && (
                        <>
                          <div className="lists" onClick={() => handlePush({ page: "publication", params: null })}>
                            <BsNewspaper style={{ fontSize: 20, color: "rgb(0, 37, 97)" }} />
                            <p style={{ marginLeft: "15px", marginBottom: 0, fontSize: 20.8, color: "rgb(0, 37, 97)" }} >EQUITY RESEARCH</p>
                          </div>
                          <hr style={{ marginTop: 5, marginBottom: 5 }} />
                        </>
                      )}

                      {/* Macroeconomics */}
                      {canViewMacroEco && (
                        <>
                          <div className="lists" onClick={() => handlePush({ page: "macroeco", params: null })}>
                            <BsNewspaper style={{ fontSize: 20, color: "rgb(0, 37, 97)" }} />
                            <p style={{ marginLeft: "15px", marginBottom: 0, fontSize: 20.8, color: "rgb(0, 37, 97)" }} >MACROECONOMICS</p>
                          </div>
                          <hr style={{ marginTop: 5, marginBottom: 5 }} />
                        </>
                      )}

                      {/* Video */}
                      {canViewVideo && (
                        <>
                          <div style={{ marginBottom: "15px", display: "flex" }} className="lists" onClick={() => setMenu(menuItem ? false : true)} >
                            <MdOndemandVideo style={{ fontSize: 20, color: "rgb(0, 37, 97)" }} />
                            <h4 style={{ marginLeft: "15px", marginBottom: 0, fontSize: 20.8, color: "rgb(0, 37, 97)" }} >RECORDED LIVE SESSION</h4>
                          </div>

                          {menuItem && (
                            <>
                              <MdKeyboardArrowDown className="icons-arrow" />
                              <div>
                                {(sections || []).map((s, i, ss) => (
                                  <div key={i} onClick={() => handlePush({ page: "video", params: s.sectionName })} className={menuItem ? "list-item" : "hind"}>
                                    <p style={{ margin: 5 }} >{s.sectionName || ""}</p>
                                    {i !== ss.length - 1 && <hr style={{ margin: 0 }} />}
                                  </div>
                                ))}
                              </div>
                            </>
                          )}
                          {!menuItem && (
                            <MdKeyboardArrowRight className="icons-arrow" />
                          )}

                          <hr style={{ marginTop: 0 }} />
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {/* Report */}
                      <>
                        <div className="lists" onClick={() => handlePush({ page: "publication", params: null })}>
                          <BsNewspaper style={{ fontSize: 20, color: "rgb(0, 37, 97)" }} />
                          <p style={{ marginLeft: "15px", marginBottom: 0, fontSize: 20.8, color: "rgb(0, 37, 97)" }} >EQUITY RESEARCH</p>
                        </div>
                        <hr style={{ marginTop: 5, marginBottom: 5 }} />
                      </>

                      {/* Macroeconomics */}
                      <>
                        <div className="lists" onClick={() => handlePush({ page: "macroeco", params: null })}>
                          <BsNewspaper style={{ fontSize: 20, color: "rgb(0, 37, 97)" }} />
                          <p style={{ marginLeft: "15px", marginBottom: 0, fontSize: 20.8, color: "rgb(0, 37, 97)" }} >MACROECONOMICS</p>
                        </div>
                        <hr style={{ marginTop: 5, marginBottom: 5 }} />
                      </>

                      {/* Video */}
                      <>
                        <div style={{ display: "flex", alignItems: "center" }} className="lists" onClick={() => setMenu(menuItem ? false : true)} >
                          <MdOndemandVideo style={{ fontSize: 20, color: "rgb(0, 37, 97)" }} />
                          <h4 style={{ marginLeft: "15px", marginBottom: 5, fontSize: 20.8, color: "rgb(0, 37, 97)" }} >RECORDED LIVE SESSION</h4>
                          {menuItem ? <MdKeyboardArrowDown className="icons-arrow" /> : <MdKeyboardArrowRight className="icons-arrow" />}
                        </div>

                        {menuItem && (
                          <>
                            <div>
                              {(sections || []).map((s, i, ss) => (
                                <div key={i} onClick={() => handlePush({ page: "video", params: s.sectionName })} className={menuItem ? "list-item" : "hind"}>
                                  <p style={{ margin: 5 }} >{s.sectionName || ""}</p>
                                  {i !== ss.length - 1 && <hr style={{ margin: 0 }} />}
                                </div>
                              ))}
                            </div>
                          </>
                        )}

                        <hr style={{ marginTop: 0 }} />
                      </>
                    </>
                  )}
                  <div className="main-btn-logout" >
                    <button className="button-logout-mobile" style={{ backgroundColor: "#ee3824", fontSize: 24, marginBottom: 20 }} onClick={() => handleLogout()}>
                      LOG OUT
                    </button>
                  </div>
                </div>}
              </div>
            </Nav>
          }
          {!Auth.isUserAuthenticated() &&
            <p></p>
          }

        </Navbar>
        {(location.pathname !== "/admin" && Auth.isUserAuthenticated() && window.innerWidth >= 500) && <Row>
          <Grid id="menu-mdUp-theme2" container alignItems="center" direction="row" justify="center" style={{ padding: 16 }}>
            <Grid item xs={12} lg={10}>
              <Grid id="menu-mdUp-theme2" container alignItems="center" direction="row" justify="center">
                <Box component={Grid} onMouseOver={handleUnClick} display={{ xs: "none", lg: "block" }} style={{ zIndex: 1050 }}>
                  <Button onClick={() => history.push("/dashboard")}>HOME</Button>
                </Box>

                {/* Report */}
                {_isAdmin
                  ? (
                    <Grid onMouseOver={handleUnClick} item xs={4} lg={3} container justify="center" style={{ zIndex: 1050 }} >
                      <Button onClick={() => history.push("/publication")} >EQUITY RESEARCH</Button>
                    </Grid>
                  ) : (
                    canViewReport && (
                      <Grid onMouseOver={handleUnClick} item xs={4} lg={3} container justify="center" style={{ zIndex: 1050 }} >
                        <Button onClick={() => history.push("/publication")} >EQUITY RESEARCH</Button>
                      </Grid>
                    )
                  )
                }

                {/* Macroeconomics */}
                {_isAdmin
                  ? (
                    <Grid onMouseOver={handleUnClick} item xs={4} lg={3} container justify="center" style={{ zIndex: 1050 }} >
                      <Button onClick={() => history.push("/macroeco")}>MACROECONOMICS</Button>
                    </Grid>
                  ) : (
                    canViewMacroEco && (
                      <Grid onMouseOver={handleUnClick} item xs={4} lg={3} container justify="center" style={{ zIndex: 1050 }} >
                        <Button onClick={() => history.push("/macroeco")}>MACROECONOMICS</Button>
                      </Grid>
                    )
                  )
                }

                {/* Video */}
                {_isAdmin
                  ? (
                    <Grid item sm={4} lg={3} container justify="center">
                      <Menu anchorEl={anchorEl} sections={sections} setAnchorEl={setAnchorEl} setSection={setSection} />
                    </Grid>
                  ) : (
                    canViewVideo && (
                      <Grid item sm={4} lg={3} container justify="center">
                        <Menu anchorEl={anchorEl} sections={sections} setAnchorEl={setAnchorEl} setSection={setSection} />
                      </Grid>
                    )
                  )
                }
              </Grid>
            </Grid>
          </Grid>
          <hr id="hr" style={{ width: "90%", margin: "auto", marginTop: "-15px", border: '1px solid #F5F5F5' }} />
        </Row>}
      </div>
    )
  }
}

export default NavBar
